import { initialFilterTable } from "../../component/atoms/Tabel"
import { createSlice } from "@reduxjs/toolkit"

const initState = {
  pageData: [],
  page: initialFilterTable,
  combobox: [],
  data: undefined,
  passwordReset: null,
  userNew: undefined
}

export const AccountSlice = createSlice({
  name: "account",
  initialState: initState,
  reducers: {
    getPage: (state, action) => {
      state.data = action.payload
    },
    setPageData: (state, action) => {
      const { pageData, page } = action.payload
      state.pageData = pageData
      state.page = page
    },
    setPasswordReset: (state, action) => {
      state.passwordReset = action.payload
    },
    setCreateUser: (state, action) => {
      state.userNew = action.payload
    }
  }
})
